module.exports = require("./interopRequireDefault.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/interop-require-default.js
 ** module id = 152
 ** module chunks = 0
 **/